export type MenuItem = {
  key?: string
  label?: string
  icon?: string
  link?: string
  collapsed?: boolean
  subMenu?: any
  isTitle?: boolean
  badge?: any
  parentKey?: string
  disabled?: boolean
  access?: string[]
  alwaysVisible?: boolean
}

export const MENU: MenuItem[] = [
  {
    key: 'general',
    label: 'GENERAL',
    isTitle: true,
  },
  // {
  //   key: 'dashboards',
  //   icon: 'iconamoon:home-duotone',
  //   label: 'Dashboards',
  //   collapsed: false,
  //   subMenu: [
  //     {
  //       key: 'dashboard-analytics',
  //       label: 'Analytics',
  //       link: 'dashboard/analytics',
  //       parentKey: 'dashboards',
  //     },
  //     {
  //       key: 'dashboard-finance',
  //       label: 'Finance',
  //       link: 'dashboard/finance',
  //       parentKey: 'dashboards',
  //     },
  //     {
  //       key: 'dashboard-sales',
  //       label: 'Sales',
  //       link: 'dashboard/sales',
  //       parentKey: 'dashboards',
  //     },
  //   ],
  // },
  {
    key: 'dashboard-analytics',
    icon: 'iconamoon:home-duotone',
    label: 'Dashboard',
    link: 'dashboard/analytics',
    access: ['p3Xn8Kq5Wz1Mv7Rb9Tc2Lj6Hd']
  },
  {
    key: 'apps',
    label: 'APPS',
    isTitle: true,
  },
  {
    key: 'app-live-traffic',
    icon: 'iconamoon:trend-up-duotone',
    label: 'Live Traffic',
    link: '/livetraffic',
    access: ['t6p3ykr9mwnx4bqzj8hcvldsf']
  },
  {
    key: 'app-project-details',
    icon: 'iconamoon:briefcase-duotone',
    label: 'Project Details',
    link: '/project-detail',
    access: ['dervxajokikqbzugyd9z9ww52']
  },
  {
    key: 'apps-accounting-dashboard',
    icon: 'iconamoon:credit-card-thin',
    label: 'Accounting Dashboard',
    link: '/accounting-dashboard',
    access: ['8b0nyhmufv0ybz5udtd4wj6on']
  },
  {
    key: 'apps-suppliers',
    icon: 'iconamoon:invoice-duotone',
    label: 'Suppliers',
    link: '/supplier-list',
    access: ['hbgilyq5oi946u6xjwde79s8k']
  },
  {
    key: 'apps-company',
    icon: 'iconamoon:invoice-duotone',
    label: 'Company Details',
    link: '/company-details',
    access: ['ujjdZ8m9W7XzRnYjtBrdN9wZt']
  },
  {
    key: 'app-customers',
    icon: 'iconamoon:shopping-bag-duotone',
    label: 'Customer',
    link: '/clients-list',
    access: ['0zxy6f8bzzlbcx29ppjhivgs0']
  },
  {
    key: 'app-client-supply',
    icon: 'iconamoon:invoice-duotone',
    label: 'Client Supply',
    link: '/client-supply-list',
    access: ['upua47hz10bosmcufvp8ztvt2']
  },
  {
    key: 'app-bids',
    icon: 'iconamoon:shopping-bag-duotone',
    label: 'Bids',
    link: '/bid-list',
    access: ['xxu8wwy40gzvy9jffzjwnvk65']
  },
  {
    key: 'apps-accounting',
    icon: 'iconamoon:shopping-bag-duotone',
    label: 'Accounting',
    collapsed: false,
    subMenu: [
      {
        key: 'invoice-list',
        label: 'Invoice List',
        link: '/invoice-list',
        parentKey: 'apps-accounting',
        access: ['8b0nyhmufv0ybz5udtd4wj6on']
      },
      {
        key: 'client-invoice',
        label: 'Client Invoice Reminder',
        link: '/client-invoice',
        parentKey: 'apps-accounting',
        access: ['8b0nyhmufv0ybz5udtd4wj6on']
      },
      {
        key: 'invoice-payment',
        label: 'Invoice Payment',
        link: '/invoice-payment',
        parentKey: 'apps-accounting',
        access: ['8b0nyhmufv0ybz5udtd4wj6on']
      },
      // {
      //   key: 'supplier-invoice',
      //   label: 'Supplier Invoice',
      //   link: '/supplier-invoice',
      //   parentKey: 'apps-accounting',
      // },
    ],
    access: ['8b0nyhmufv0ybz5udtd4wj6on']
  },
  {
    key: 'app-question-library',
    icon: 'iconamoon:credit-card-thin',
    label: 'Question Library',
    link: '/question-library',
    access: ['38ok6d6nq2kl4uib06sivtmv8']
  },
  {
    key: 'final-ids',
    label: 'Final Ids',
    link: '/final-ids',
    icon: 'iconamoon:invoice-duotone',
    access: ['1ux8vxtggmng806xp0g6dhirn']

  },
  {
    key: 'downloads',
    label: 'Downloads',
    link: '/downloads',
    icon: 'iconamoon:cloud-download-duotone',
    access: ['a5mc8idzyrioizhbzsh8ni8wb']

  },
  // {
  //   key: 'apps-final-ids',
  //   icon: 'iconamoon:shopping-bag-duotone',
  //   label: 'Final Ids',
  //   collapsed: false,
  //   subMenu: [
  //      {
  //       key: 'scrub-final-ids',
  //       label: 'Scrub Final Ids',
  //       link: '/scrub-final-ids',
  //       parentKey: 'apps-final-ids',
  //     },
  //     {
  //       key: 'final-ids',
  //       label: 'Final Ids',
  //       link: '/final-ids',
  //       parentKey: 'apps-final-ids',
  //     },

  //   ],
  // },
]
